import { render, staticRenderFns } from "./ManageStockExit.vue?vue&type=template&id=32a089bf&scoped=true"
import script from "./ManageStockExit.vue?vue&type=script&lang=js"
export * from "./ManageStockExit.vue?vue&type=script&lang=js"
import style0 from "./ManageStockExit.vue?vue&type=style&index=0&id=32a089bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a089bf",
  null
  
)

export default component.exports